// extracted by mini-css-extract-plugin
export default {"container":"Industries_container__d5zZY","blocks":"Industries_blocks__XFhio"};